import { IOmniaSettings, IOmniaSettingsKey } from "../../types"

export function createLocalSettings() {

    const root: { [key: string]: IOmniaSettings } = {}

    return {
        get
    }

    function get(namespace: string): IOmniaSettings {

        namespace = (namespace ? "omnia." + namespace : "omnia")

        let settings = root[namespace]

        if (!settings) {
            settings = new LocalSettings(namespace)
            root[namespace] = settings
        }

        return settings

    }

}

export class LocalSettings implements IOmniaSettings {


    constructor(private ns: string) {
    }

    getSettings(namespace: string): IOmniaSettings {
        let ns = this.ns + "." + namespace;
        return new LocalSettings(ns);
    }

    getKey(key: string): IOmniaSettingsKey {
        return {
            key,
            get: (defaultValue?: any) => this.get(key, defaultValue),
            set: (value: any, defaultValue?: any) => this.set(key, value, defaultValue)
        }
    }

    get(key: string, defaultValue?: any): any {
        key = this.ns + "." + key
        var value = localStorage.getItem(key);
        return (value == null ? defaultValue : JSON.parse(value))
    }

    set(key: string, value: any, defaultValue?: any) {

        key = this.ns + "." + key

        if (value == defaultValue) {
            localStorage.removeItem(key)
        }
        else {
            localStorage.setItem(key, JSON.stringify(value))
        }

    }

    remove(key: string) {
        key = this.ns + "." + key
        localStorage.removeItem(key)
    }

}
